<template>
  <div class="h-screen flex flex-col bg-white shadow-sm transition-all duration-300 ease-in-out border-r border-gray-100 overflow-hidden" :style="thestyle">
    <!-- Logo Section -->
    <div class="h-20 flex items-center px-6 mb-4 flex-shrink-0 border-b border-gray-50">
      <div class="flex items-center space-x-3">
        <div class="p-2 rounded-lg bg-blue-50 text-[#0d47a1] flex-shrink-0">
          <i class="material-icons text-2xl">payments</i>
        </div>
        <span v-if="thestyle != 'width: 5em'" class="text-lg font-black text-[#0d47a1] tracking-wider animate__animated animate__fadeIn whitespace-nowrap uppercase">
          DIYPAYROLL
        </span>
      </div>
    </div>

    <!-- Navigation Section -->
    <nav class="flex-1 px-3 space-y-1 overflow-y-auto hide-scrollbar pt-4">
      <HomeMenu :thestyle="thestyle"></HomeMenu>
    </nav>

    <!-- Bottom Section (User Profile) -->
    <div class="p-4 border-t border-gray-50 flex-shrink-0 bg-gray-50/30">
      <div v-if="me.id" class="flex items-center space-x-3 px-2 py-3 rounded-lg hover:bg-white transition cursor-pointer group border border-transparent hover:border-gray-100 shadow-sm shadow-transparent hover:shadow-gray-200/50" @click="$router.push('/employee/'+me.id)">
        <img src="/images/profile.jpg" class="w-10 h-10 rounded-full border-2 border-white object-cover shadow-sm flex-shrink-0 group-hover:border-blue-100 transition-colors"/>
        <div v-if="thestyle != 'width: 5em'" class="flex-1 min-w-0 animate__animated animate__fadeIn">
          <p class="text-sm font-bold text-gray-900 truncate">{{ me.first_name }} {{ me.last_name }}</p>
          <p class="text-[10px] text-gray-400 truncate uppercase font-black tracking-widest">Administrator</p>
        </div>
      </div>
      
      <button v-if="!no_auth" @click.stop="logout" class="w-full mt-2 flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-500 hover:bg-red-50 hover:text-red-600 transition-all group">
        <i class="material-icons text-xl opacity-70 group-hover:opacity-100">logout</i>
        <span v-if="thestyle != 'width: 5em'" class="text-sm font-bold animate__animated animate__fadeIn">Sign Out</span>
      </button>
    </div>
  </div>
</template>

<script>
import HomeMenu from '../components/HomeMenu.vue'
import get_api from "../service/api.js"
import base_url from "../service/base_url.js"

export default {
  name: "SideBar",
  props: ["thestyle"],
  components: {
    HomeMenu
  },
  created() {
    this.api = get_api(this.$router)
    if (localStorage.getItem("XPAYROLLaccess_token")) {
      this.api.get(`${base_url}/me`).then((resp) => {
        this.me = resp.data.data
      })
    }
  },
  data() {
    return {
      me: {}
    }
  },
  computed: {
    no_auth() {
      return !localStorage.getItem('XPAYROLLaccess_token')
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("XPAYROLLaccess_token")
      this.$store.commit('set_access_token', "")
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
